<script>
    import { preventDefault } from 'svelte/legacy';

    import { createEventDispatcher } from 'svelte';
    import { format } from 'svelte-i18n';

    let { elements = [], showDropdown = false, element_being_selected } = $props();

    const dispatch = createEventDispatcher();
</script>
<style>
    .fa-times {
        cursor: pointer;
    }
    .dropdown-menu{
        left: 495px;
        max-width: 420px;
        width: 390px;
        top: -87px;
        height: 565px;
        overflow-y: scroll;
        overflow-x: hidden;
    }
    .dropdown-menu:before{
        content: '';
        position: absolute;
        top: 68%;
        left: -23px;
        border-top: 12px solid transparent;
        border-left: 12px solid transparent;
        border-right: 12px solid white;
        border-bottom: 12px solid transparent;
    }
    .dropdown-item {
        padding: 1em 15px;
        border-bottom: 1px solid #ccc;
        text-wrap: auto;
    }
    .dropdown-header{
        border-bottom: 1px solid #ccc;
    }
</style>
<div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" class:show={showDropdown}>
    <div class="dropdown-header">{$format("buttons.select")} {element_being_selected || ''}
        <span class="float-end">
            <i class="fas fa-times" onclick={preventDefault(()=>dispatch("closeSearchPanel"))}></i>
        </span>
    </div>
    {#if !elements.length}
        <div class="dropdown-item">{$format("results_not_found")}</div>
    {:else}
        {#each elements as element}
            <div class="dropdown-item" style="cursor: pointer;" onclick={preventDefault(()=>dispatch("selectElement", element))}>
                {element.nickname || element.name}
            </div>
        {/each}
    {/if}

</div>
